/*
  APS range reviews (Feefo). Shows the combined reviews of every model in a linked range by asking
  Feefo for all the range's SKUs at once (product_sku=A,B,C), which includes reviews filed under the
  old website's codes.
  [data-apsr-stars]   data-merchant, data-skus, optional data-link  -> stars + (count)
  [data-apsr-reviews] data-merchant, data-skus                       -> full reviews block
  On product pages the reviews block also replaces the Feefo stars under the title.
*/
(function () {
  if (window.__apsFeefoRange) { if (window.__apsFeefoRange.scan) window.__apsFeefoRange.scan(); return; }
  var API = 'https://api.feefo.com/api/10/reviews/';
  var cache = {};

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function q(m, skus) {
    return 'merchant_identifier=' + encodeURIComponent(m) + '&product_sku=' + encodeURIComponent(skus) + '&since_period=ALL';
  }
  function summary(m, skus) {
    var k = m + '|' + skus;
    if (!cache[k]) cache[k] = fetch(API + 'summary/product?' + q(m, skus)).then(function (r) { return r.json(); });
    return cache[k];
  }
  function reviews(m, skus, page, size) {
    return fetch(API + 'product?' + q(m, skus) + '&page_size=' + size + '&page=' + page).then(function (r) { return r.json(); });
  }
  var STAR = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 1.8l3.1 6.6 7.2.8-5.4 4.9 1.5 7.1L12 17.6l-6.4 3.6 1.5-7.1-5.4-4.9 7.2-.8z"/></svg>';
  var FIVE = STAR + STAR + STAR + STAR + STAR;
  function stars(r, cls) {
    var pct = Math.max(0, Math.min(100, (Number(r) || 0) / 5 * 100));
    return '<span class="apsr-stars ' + (cls || '') + '" role="img" aria-label="' + (Number(r) || 0).toFixed(1) + ' out of 5 stars">' +
      '<span class="apsr-stars__bg">' + FIVE + '</span>' +
      '<span class="apsr-stars__fg" style="width:' + pct.toFixed(1) + '%">' + FIVE + '</span></span>';
  }
  function modelName(p) {
    if (!p) return '';
    var t = (p.title || '').replace(/^AllPondSolutions\s+/i, '').replace(/^All Pond Solutions\s+/i, '');
    return t || p.sku || '';
  }
  function dateText(iso) {
    try { return new Date(iso).toLocaleDateString('en-GB', { day: 'numeric', month: 'short', year: 'numeric' }); } catch (e) { return ''; }
  }

  function css() {
    if (document.getElementById('apsr-css')) return;
    var s = document.createElement('style');
    s.id = 'apsr-css';
    s.textContent =
      '.apsr-stars{--s:15px;--g:2px;position:relative;display:inline-block;line-height:0;vertical-align:middle;flex-shrink:0}' +
      '.apsr-stars__bg,.apsr-stars__fg{display:flex;gap:var(--g)}' +
      '.apsr-stars svg{width:var(--s);height:var(--s);flex:0 0 var(--s);fill:currentColor;display:block}' +
      '.apsr-stars__bg{color:#d6dde0}.apsr-stars__fg{position:absolute;left:0;top:0;overflow:hidden;color:#ffc700}' +
      '.apsr-inline{display:inline-flex;align-items:center;gap:6px;font-size:13px;color:#35606a;text-decoration:none}' +
      '.apsr-inline:hover{text-decoration:underline}' +
      '.apsr-card .apsr-count{font-size:14px!important;color:#1b4751!important;font-weight:600!important}' +
      '.apsr-card .apsr-inline{gap:7px}' +
      '.apsr-card .apsr-stars{--s:20px;--g:0.5px}' +
      '.aps-stars .apsr-count{font-size:14px!important;color:#1b4751!important;font-weight:600!important}' +
      '.aps-stars .apsr-inline{gap:7px}' +
      '.aps-stars .apsr-stars{--s:20px;--g:0.5px}' +
      '.aps-stars.apsr-has-range>*:not(.apsr-inline){display:none!important}' +
      '.apsr{color:#1b4751;max-width:1240px;margin:0 auto;padding:40px 20px;box-sizing:border-box}' +
      '.apsr h2{font-size:24px;font-weight:600;margin:0 0 20px}' +
      '.apsr__top{display:grid;grid-template-columns:1fr;gap:20px;padding:20px;background:#f1f3f5;border-radius:16px;margin-bottom:24px}' +
      '@media(min-width:769px){.apsr__top{grid-template-columns:240px 1fr;align-items:center}}' +
      '.apsr__score{display:flex;flex-direction:column;gap:6px}' +
      '.apsr__big{font-size:40px;font-weight:700;line-height:1}' +
      '.apsr__score .apsr-stars{--s:24px;--g:3px}' +
      '.apsr__based{font-size:13px;color:#5b7880}' +
      '.apsr__bars{display:flex;flex-direction:column;gap:6px}' +
      '.apsr__bar{display:grid;grid-template-columns:52px 1fr 40px;gap:10px;align-items:center;font-size:13px;color:#35606a}' +
      '.apsr__track{height:8px;background:#dfe6e8;border-radius:4px;overflow:hidden}' +
      '.apsr__fill{height:100%;background:#ffc700}' +
      '.apsr__list{display:flex;flex-direction:column}' +
      '.apsr__item{padding:18px 0;border-bottom:1px solid #e8e8e1;display:flex;flex-direction:column;gap:6px}' +
      '.apsr__meta{display:flex;flex-wrap:wrap;gap:8px 14px;align-items:center;font-size:13px;color:#5b7880}' +
      '.apsr__name{font-weight:600;color:#1b4751}' +
      '.apsr__text{font-size:15px;line-height:1.6;margin:0}' +
      '.apsr__model{font-size:12px;color:#007d8b;background:#e6f4f6;border-radius:10px;padding:2px 8px;align-self:flex-start}' +
      '.apsr__more{margin:20px auto 0;display:block;background:#fff;border:1px solid #d9dfe2;border-radius:24px;padding:10px 22px;font-size:14px;font-weight:600;color:#007d8b;cursor:pointer}' +
      '.apsr__more:hover{border-color:#0095a6}' +
      '.apsr__feefo{margin-top:14px;font-size:12px;color:#80979d}';
    document.head.appendChild(s);
  }

  function renderStars(el) {
    if (el.getAttribute('data-apsr-done')) return;
    el.setAttribute('data-apsr-done', '1');
    var m = el.getAttribute('data-merchant'), skus = el.getAttribute('data-skus');
    if (!m || !skus) return;
    summary(m, skus).then(function (d) {
      var r = d && d.rating ? d.rating.rating : 0, n = d && d.meta ? d.meta.count : 0;
      if (!n) return;
      var link = el.getAttribute('data-link');
      el.innerHTML = (link ? '<a class="apsr-inline" href="' + esc(link) + '">' : '<span class="apsr-inline">') +
        stars(r) + '<span class="apsr-count">(' + n + ')</span>' + (link ? '</a>' : '</span>');
    }).catch(function () {});
  }

  function renderReviews(el) {
    if (el.getAttribute('data-apsr-done')) return;
    el.setAttribute('data-apsr-done', '1');
    var m = el.getAttribute('data-merchant'), skus = el.getAttribute('data-skus');
    if (!m || !skus) return;
    var page = 1, size = 10, pages = 1;
    summary(m, skus).then(function (d) {
      var n = d && d.meta ? d.meta.count : 0;
      if (!n) { el.innerHTML = ''; return; }
      var rt = d.rating || {}, pr = rt.product || {};
      var bars = '';
      for (var s = 5; s >= 1; s--) {
        var c = pr[s + '_star'] || 0, w = n ? (c / n * 100) : 0;
        bars += '<div class="apsr__bar"><span>' + s + ' star</span><span class="apsr__track"><span class="apsr__fill" style="display:block;width:' + w.toFixed(1) + '%"></span></span><span>' + c + '</span></div>';
      }
      el.innerHTML =
        '<div class="apsr" id="apsr-reviews">' +
          '<h2>Customer reviews</h2>' +
          '<div class="apsr__top">' +
            '<div class="apsr__score"><span class="apsr__big">' + (Number(rt.rating) || 0).toFixed(1) + '</span>' + stars(rt.rating) +
            '<span class="apsr__based">Based on ' + n + ' reviews across the range</span></div>' +
            '<div class="apsr__bars">' + bars + '</div>' +
          '</div>' +
          '<div class="apsr__list" data-apsr-list></div>' +
          '<button type="button" class="apsr__more" data-apsr-more hidden>Show more reviews</button>' +
          '<p class="apsr__feefo">Independent verified reviews collected by Feefo</p>' +
        '</div>';
      var list = el.querySelector('[data-apsr-list]'), more = el.querySelector('[data-apsr-more]');
      function load() {
        more.disabled = true;
        reviews(m, skus, page, size).then(function (data) {
          var meta = data && data.summary && data.summary.meta;
          pages = meta ? meta.pages : 1;
          (data.reviews || []).forEach(function (rv) {
            var p = (rv.products && rv.products[0]) || {};
            var text = p.review || (rv.service && rv.service.review) || '';
            if (!text) return;
            var item = document.createElement('div');
            item.className = 'apsr__item';
            item.innerHTML =
              '<div class="apsr__meta">' + stars(p.rating && p.rating.rating) +
                '<span class="apsr__name">' + esc((rv.customer && rv.customer.display_name) || 'Verified customer') + '</span>' +
                '<span>' + esc(dateText(p.created_at)) + '</span></div>' +
              '<p class="apsr__text">' + esc(text) + '</p>' +
              (p.product ? '<span class="apsr__model">' + esc(modelName(p.product)) + '</span>' : '');
            list.appendChild(item);
          });
          more.hidden = page >= pages;
          more.disabled = false;
        }).catch(function () { more.disabled = false; });
      }
      more.addEventListener('click', function () { page += 1; load(); });
      load();

      // Product page: swap the Feefo stars under the title for the range stars.
      var head = document.querySelector('.aps-pdp .aps-stars');
      if (head && !head.querySelector('.apsr-inline')) {
        var wrap = document.createElement('span');
        wrap.innerHTML = '<a class="apsr-inline" href="#apsr-reviews">' + stars(rt.rating) + '<span class="apsr-count">' + (Number(rt.rating) || 0).toFixed(1) + ' (' + n + ' reviews)</span></a>';
        head.appendChild(wrap.firstChild);
        head.classList.add('apsr-has-range');
      }
    }).catch(function () {});
  }

  function scan() {
    css();
    document.querySelectorAll('[data-apsr-stars]').forEach(renderStars);
    document.querySelectorAll('[data-apsr-reviews]').forEach(renderReviews);
  }
  window.__apsFeefoRange = { scan: scan };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan); else scan();
})();
